// extracted by mini-css-extract-plugin
export var lg = "_17-4";
export var md = "_17-3";
export var sm = "_17-2";
export var xs = "_17-1";
export var xxs = "_17-0";